export default "src/content/themes/association-wordpress-theme/img/119f57d7b93f877e5c74a19bc0fa06e5.png";